import { styled } from "goober";

const Divider = styled("div")<{
  $color?: string;
}>`
  width: 100%;
  height: 0.0625rem;
  background: ${({ $color }) => $color || "var(--shade3-15)"};
`;

export default Divider;
